import { API_VERSION_ONE, handleAPI } from "../../../../itrust_common/utils/apiUtils";

export function ediClearingHouseServicesLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_on`;

  const method = 'GET'
  return {
    type: 'EDI_CLEARING_HOUSE_SERVICES_LOAD',
    payload: handleAPI(url, { ...filters, category: "edi_clearing_house" }, method)
  }
}

export function ediClearingHouseServiceUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/add_on/${data.id}`;
  const method = 'PUT'
  return {
    type: 'EDI_CLEARING_HOUSE_SERVICE_UPDATE',
    payload: handleAPI(url, filters, method, { add_on: data })
  }
}


export function verifyEDIEligibility(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/logs`;
  const method = 'POST'
  return {
    type: 'EDI_ELIGIBILITY_VERIFICATION',
    payload: handleAPI(url, filters, method)
  }
}

export function ediRejectionLogsLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/rejection_logs`;
  const method = 'GET';
  return {
    type: 'EDI_REJECTION_LOGS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function ediRejectionLogsUpdate(filters, data) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/rejection_logs/${data.id}`;
  const method = 'PUT';
  return {
    type: 'EDI_REJECTION_LOGS_UPDATE',
    payload: handleAPI(url, filters, method, { log: { ...data } })
  }
}
export function ediLogsExport(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/export_csv`;
  const method = 'GET';
  return {
    type: 'EDI_REJECTION_LOGS_EXPORT',
    payload: handleAPI(url, filters, method)
  }
}


export function ediClearingHouseEdit(data) {
  return {
    type: 'EDI_CLEARING_HOUSE_EDIT',
    data
  };
}

export function ediClearingHouseEditReset() {
  return {
    type: 'EDI_CLEARING_HOUSE_EDIT_RESET',
  };
}

export function ediFilesLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/edi_files`;
  const method = 'GET';
  return {
    type: 'EDI_FILES_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function ediFileLoad(id, filters = {}) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/edi_files/${id}`;
  const method = 'GET';
  return {
    type: 'EDI_FILE_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function ediFilesSyncRemits() {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/edi_files/sync_remits`;
  const method = 'POST';
  return {
    type: 'EDI_FILES_SYNC_REMITS',
    payload: handleAPI(url, {}, method)
  }
}

export function ediFileProcessRemit(id, processData) {
  const url = `/${API_VERSION_ONE}/add_ons/edi_clearing_house/edi_files/${id}/process_remit`;
  const method = 'POST';
  return {
    type: 'EDI_FILE_PROCESS_REMIT',
    payload: handleAPI(url, {}, method, { process_data: processData })
  }
}

export function ediClearingHouseServicesReset() {
  return {
    type: 'EDI_CLEARING_HOUSE_SERVICES_RESET'
  }
}